import EmberRouter from '@ember/routing/router';
import config from 'scaleflow/config/environment';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {
  this.route('roadmap', function () {
    this.route('radar');
    this.route('now-next-later');
    this.route('settings');
    this.route('strategy', function () {
      this.route('index');
      this.route('create');
      this.route('roadmap', { path: '/:roadmap_id' }, function () {
        this.route('edit');
        this.route('lanes');
        this.route('grid');
      });
    });
  });

  this.route('backlog', function () {
    this.route('bons');
    this.route('initiatives', function () {
      this.route('create');
      this.route('initiative', { path: '/:initiative' }, function () {
        this.route('uncertainties');
        this.route('waiting-for-answers');
        this.route('planning', function () {
          this.route('weeks');
          this.route('workstreams', function () {
            this.route('workstream', { path: '/:workstream' }, function () {
              this.route('archive');
            });

            this.route('unfiled', function () {
              this.route('archive');
            });
          });
        });
        this.route('document');
        this.route('back-of-a-napkin');
        this.route('settings', function () {
          this.route('general-details');
          this.route('planning-and-people');
          this.route('strategy');
        });
        this.route('weeks');
        this.route('workstreams');
        this.route('overview');
        this.route('description');
        this.route('investments');
        this.route('returns');
        this.route('notes');
        this.route('knowledge-base', function () {
          this.route('list');

          this.route('file', function () {
            this.route('file-name', { path: '/:file_name' });
          });
        });
        this.route('artifacts');
        this.route('metrics');
      });
    });

    this.route('ideas', function () {
      this.route('list', function () {
        this.route('create');
      });
      this.route('idea', { path: '/:idea_id' }, function () {
        this.route('edit');
        this.route('description');
      });
    });
  });

  this.route('operations', function () {
    this.route('teams', function () {
      this.route('team', { path: '/:team' }, function () {
        this.route('settings');
        this.route('check-in', function () {
          this.route('archive', function () {
            this.route('questions');
            this.route('lessons-learned');
            this.route('to-figure-outs');
            this.route('uncertainties');
            this.route('waiting-for-answers');
          });
        });
        this.route('goals');
        this.route('initiatives');
        this.route('roadmap');
        this.route('home');
      });
    });
  });

  this.route('settings', function () {
    this.route('organisation');
    this.route('account');
    this.route('financials');
    this.route('tags', function () {
      this.route('create');
      this.route('edit', { path: '/:theme_id/edit' });
    });
    this.route('departments', function () {
      this.route('list', function () {
        this.route('create');
      });
      this.route('department', { path: '/:department_id' }, function () {
        this.route('edit');
      });
    });
    this.route('areas', function () {
      this.route('list', function () {
        this.route('create');
      });
      this.route('area', { path: '/:area_id' }, function () {
        this.route('edit');
      });
    });

    this.route('customers', function () {
      this.route('list', function () {
        this.route('create');
      });
      this.route('customer', { path: '/:customer_id' }, function () {
        this.route('edit');
      });
    });

    this.route('groups', function () {
      this.route('list', function () {
        this.route('create');
      });
      this.route('group', { path: '/:group_id' }, function () {
        this.route('edit');
      });
    });

    this.route('agents', function () {
      this.route('list', function () {
        this.route('create');
      });
      this.route('agent', { path: '/:agent_id' }, function () {
        this.route('edit');
      });
    });

    this.route('roles', function () {
      this.route('list', function () {
        this.route('create');
      });
      this.route('role', { path: '/:role_id' }, function () {
        this.route('edit');
      });
    });

    this.route('teams', function () {
      this.route('active');
      this.route('archived');
      this.route('create');
    });
  });

  this.route('bookmarks');

  this.route('login');
  this.route('logout');
  this.route('authenticate');
  this.route('reset-password');

  this.route('roles', function () {
    this.route('role');
  });

  this.route('insights');

  /**
   * NEW IA
   */
  this.route('planning', function () {
    this.route('dashboard', function () {
      this.route('capacity', function () {
        this.route('teams');
        this.route('weeks');
        this.route('roles');
      });
      this.route('roi');
      this.route('balance', function () {
        this.route('edit');
        this.route('view');
      });
      this.route('grid');
      this.route('lanes');
      this.route('overview', function () {
        this.route('grid');
        this.route('lanes');
        this.route('timeline');
        this.route('table');
      });
    });
  });

  this.route('business', function () {
    this.route('goals', function () {
      this.route('list');
      this.route('create');
      this.route('goal', { path: '/:goal_id' }, function () {
        this.route('edit');
        this.route('description');
        this.route('initiatives');
        this.route('subgoals');
        this.route('metrics');
      });
    });
    this.route('financials');

    this.route('metrics', function () {
      this.route('create');
      this.route('metric', { path: '/:metric_id' }, function () {
        this.route('edit');
      });
      this.route('list');
    });
  });

  this.route('claim');
  this.route('resources', function () {
    this.route('people', function () {
      this.route('active');
      this.route('inactive');
      this.route('create');
      this.route('person', { path: '/:person_id' }, function () {
        this.route('edit');
      });
    });
  });

  this.route('artifacts', function () {
    this.route('artifact', { path: '/:artifact_id' }, function () {
      this.route('view');
    });
  });

  this.route('data', function () {
    this.route('list');

    this.route('file', function () {
      this.route('file-name', { path: '/:file_name' });
    });
    this.route('rfi');
  });

  this.route('recommendations');
  this.route('home');
  this.route('company');
  this.route('departments', function () {
    this.route('department', { path: '/:department_id' }, function () {
      this.route('home');
      this.route('goals');
      this.route('roadmap');
      this.route('initiatives');
      this.route('settings');
    });
  });

  this.route('scans', function () {
    this.route('scan', { path: '/:scan_id' }, function () {
      this.route('product', { path: '/:product_id' }, function () {
        this.route('observations');
        this.route('conversations');
        this.route('automated-reports');
        this.route('verified-reports');
      });
      this.route('processing');
    });
    this.route('list', function () {
      this.route('active');
      this.route('archived');
    });
    this.route('new');
  });

  this.route('connectors', function () {
    this.route('manual');
    this.route('gitlab');
    this.route('github');
    this.route('github-public');
    this.route('success', { path: '/:connector_id/success' });
  });
  this.route('404', { path: '/*path' });
});
